import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { withQuery } from '../../hoc/withGraphql';

import DefaultPicIcon from './DefaultPicIcon';
import history from '../../core/history';

import s from './Avatar.css';

const Avatar = ({
  source,
  title,
  height,
  width,
  className,
  withLink,
  linkClassName,
  profileId,
  profilePictureData: {
    loading, userAccount
  },
  isUser,
  type,
  staticImage,
  isTransparentHeader
}) => {

  const path = '/images/avatar/' + type + '_';
  let imgSource = null;
  let isDefault = true;

  if (isUser) {
    if (staticImage) {
      imgSource = source !== null ? source : null;
      isDefault = source === null;
    } else if (!loading && userAccount != null) {
      imgSource = userAccount.picture !== null ? path + userAccount.picture : null;
      isDefault = userAccount.picture === null;
    }
  } else {
    if (staticImage) {
      imgSource = source !== null ? source : null;
      isDefault = source === null;
    } else {
      imgSource = source !== null ? path + source : null;
      isDefault = source === null;
    }
  }

  if (isDefault) {
    const isWhyHost = history.location && history.location.pathname.startsWith('/whyhost');
    const iconFill = isTransparentHeader ? '#ffffff' : (isWhyHost ? 'var(--primary-color)' : 'var(--primary-color)');
    const wrapperBg = isTransparentHeader ? 'transparent' : (isWhyHost ? '#ffffff' : '#ffffff');

    const iconElement = (
      <div
        className={cx(className, { [s.defaultIcon]: !isTransparentHeader }, { [s.defaultIconTransparent]: isTransparentHeader }, { ['inboxAvatarSection']: withLink })}
        style={{
          backgroundColor: wrapperBg,
        }}
      >
        <DefaultPicIcon fill={iconFill} />
      </div>
    );

    if (withLink) {
      return (
        <a href={"/users/show/" + profileId} target="_blank" className={linkClassName}>
          {iconElement}
        </a>
      );
    }

    return iconElement;
  }

  imgSource = imgSource + "?" + Math.random();

  if (withLink) {
    return (
      <a href={"/users/show/" + profileId} target="_blank" className={linkClassName}>
        <img
          src={imgSource}
          className={cx(s.imgBackground, className, 'inboxAvatarSection')}
          alt={title}
          height={height}
          width={width}
        />
      </a>
    );
  } else {
    return (
      <img
        src={imgSource}
        className={cx(s.imgBackground, className)}
        alt={title}
        height={height}
        width={width}
      />
    );
  }

}

Avatar.propTypes = {
  source: PropTypes.string,
  title: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string,
  withLink: PropTypes.bool,
  profileId: PropTypes.number,
  linkClassName: PropTypes.string,
  userId: PropTypes.string,
  profilePictureData: PropTypes.shape({
    loading: PropTypes.bool,
    account: PropTypes.shape({
      picture: PropTypes.string
    })
  }),
  isUser: PropTypes.bool,
  type: PropTypes.string,
  staticImage: PropTypes.bool,
  isTransparentHeader: PropTypes.bool
};

Avatar.defaultProps = {
  source: null,
  height: 100,
  width: 100,
  profileId: null,
  withLink: false,
  profilePictureData: {
    loading: true,
    userAccount: {
      picture: null
    }
  },
  isUser: false,
  type: 'medium',
  staticImage: false,
  isTransparentHeader: false
}

export default compose(
  withStyles(s),
  withQuery(gql`
      query userAccount($userId:String) {
          userAccount(userId:$userId) {
              picture
          }
      }
    `,
    {
      name: 'profilePictureData',
      options: (props) => ({
        variables: { userId: props.userId },
        skip: !props.isUser,
        ssr: false,
        fetchPolicy: 'network-only',
      })
    }),
)(Avatar);
